<template>
  <Block type="gongneng" class="iv-m-t-24" @on-more="toMorePage">
    <div class="iv-funciton-block iv-p-b-20">
      <ul class="iv-funciton-block-ul">
        <li class="iv-funciton-block-li iv-text-center iv-m-t-28 iv-pull-left iv-pointer" v-for="(item, index) in list" :key="index" @click="toThatPage(item)">
          <span class="iv-m-t-20 iv-funciton-block-bg">
            <IconFont :type="item.icon"></IconFont>
          </span>
          <p class="iv-fs-14 iv-fc-65 iv-m-t-8">{{item.title}}</p>
        </li>
      </ul>
    </div>
    <Modal title="自主功能入口" class="iv-class-div" v-model="isShowModal" :map="map" size="middle" :readOnly="true" buttonText="关闭" className="iv-function-modal">
      <Draggable :sort="false" v-model="allList" group="list" animation="1000" element="ul" class="iv-funciton-block-ul iv-p-l-20 iv-p-b-20" @end="dragEnd">
        <transition-group>
          <li class="iv-funciton-block-li iv-text-center iv-m-t-20 iv-pull-left iv-pointer" v-for="item in allListcopy" :key="item.index" @click="toThatPage(item)">
            <span class="iv-m-t-20 iv-funciton-block-bg">
              <IconFont :type="item.icon"></IconFont>
            </span>
            <p class="iv-fs-16 iv-fc-65 iv-m-t-8">{{item.title}}</p>
          </li>
        </transition-group>
      </Draggable>
      <div slot="footer">
        <Button type="close" class="iv-fs-14" @click="closeModal">关闭</Button>
      </div>
    </Modal>
    <Modal title="系统提示" size="small" v-model="pointsModal" className="iv-points-info-modal">
      <div class="iv-p-24 iv-text-center">
        <p class="iv-fs-16 iv-fc-65 iv-text-left">功能将在后期上线，敬请期待...</p>
        <img class="iv-m-t-8" style="height: 173px;" src="@/assets/images/index/no-points.png" >
      </div>
      <div slot="footer">
        <Button type="close" @click="refusePointsModal">关闭</Button>
      </div>
    </Modal>
  </Block>
</template>

<script>
import Draggable from 'vuedraggable'
import Block from '@/components/block'
import Modal from '@/components/modal'
import { jumpElearningPage } from '@/utils'
import IconFont from '@/components/iconfont'
import {iconConfig, titleConfig} from './block-config.js'

export default {
  name: 'functionBlock',
  data () {
    return {
      list: [],
      isShowModal: false,
      allList: [],
      allListcopy: [],
      noMore: false,
      pointsModal: false
    }
  },
  created () {
    this.map = {
      middle: '792'
    }
    this.allList = Object.keys(iconConfig).map((item, index) => ({
      title: titleConfig[item],
      type: item,
      index: index,
      icon: iconConfig[item]
    }))
    //隐掉 在线学习 等
    this.allList.map((item, i) => {
      this.allListcopy.push(item)
    })
    // this.allList.splice(this.allList.length-4, 3)
    this.list = this.allListcopy.slice(0, 10)
  },
  methods: {
    //拖拽结束
    dragEnd (param) {},
    //点击更多
    toMorePage () { 
      this.isShowModal = true
    },
    //关闭弹框
    closeModal () {
      //关闭弹框时重新赋值
      this.list = this.allListcopy.slice(0, 10)
      // this.list = this.allList.slice(0, 10)
      this.isShowModal = false
    },
    refusePointsModal () {
      this.pointsModal = false
    },
    //跳转至对应的模块
    toThatPage (item) {
      if (item.type == 'xlxx') {
        this.goHeartMailBox()
        return 
      }
      let name = ''
      if (item.type === 'zxxx') {
        jumpElearningPage('/#/index')
        return
      }
      if (item.type == 'xwzx') {
        const { href } = this.$router.resolve({
          name: 'homePage'
        })
        window.open(href, '_blank')
        return 
      }
      switch (item.type) {
        case 'xsjy': 
          name = 'voiceAdviceList'
          break
        case 'xmsb':
          name = 'projectList'
          break
        case 'pysb':
          name = 'appraisingList'
          break
        case 'hdbm':
          name = 'activityList'
          break
        case 'psdf':
          name = 'reviewList'
          break
        case 'zdsy':
          name = 'systemList'
          break
        case 'knsq': 
          name = 'difficultList'
          break
        case 'ljzm': 
          name = 'cleanCertificate'
          break
        case 'dcwj': 
          name = 'questionnaireList'
          break
        case 'zycsxy':
          name = 'declarationSignList'
          break
        case 'zjyj': 
          name = 'solicitOpinions'
          break
      }
      this.$router.push({
        name: name,
        query: {}
      })
    },
    goHeartMailBox () {
      this.$ajax({
        url: 'api-uum/module/portal/mailbox/verifyLogin',
        method: 'get',
        data: {
        },
        preventMessage: true
      }).then(({data}) => {
        if (data.code == -1) {
          this.$Message.error(data.data.message)
        } else {
          let url = `http://boehome.boe.com?app=index&mod=Index&act=index&token=${data.data.token}`
          window.open(url, '_blank')
        }
      }).catch(({data}) => {
        let urls = data.data.info
        window.open(urls)
      })
    }
  },
  components: {
    Modal,
    Block,
    Draggable,
    IconFont
  }
}
</script>

<style lang="scss" scoped>
.iv-block {
  height: 364px !important;
}
.iv-funciton-block-ul {
  overflow: hidden;
}
.iv-funciton-block-li {
  width: 108px;
  height: 108px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.09);
  // &:nth-child(6n) {
  //   margin-right: 0;
  // }
  // img {
  //   width: 48px;
  //   height: 48px;
  //   border-radius: 50%;
  // }
  p {
    font-weight: 500;
  }
  .iv-funciton-block-bg {
    color: #fff;
    display: inline-block;
    width: 48px;
    height: 48px;
    line-height: 48px;
    border-radius: 50%;
    background: url('~@/assets/images/index/blue-bg.png') no-repeat center center; 
    position: relative;
    .iconfont {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 20px;
    }
  }
}
</style>
